import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useQuery } from '@apollo/react-hooks'
import { LATEST_PRIVACY_POLICY } from '../../core/queries'
import { Markdown } from '../../../components/markdown/Markdown'
import LoadingSpinner from '../../../components/loadingSpinner'
import PublicLayout from '../../publicLayout/containers/PublicLayout'
import {
	StyledContent,
	StyledCenteredContainer
} from '../../license/containers/styles'

const TermsOfUsePage: FC = () => {
	const { t } = useTranslation()

	const { data, loading, error } = useQuery(LATEST_PRIVACY_POLICY, {
		fetchPolicy: 'network-only'
	})

	const latest = data?.latestTermsOfUse

	let content = null

	if (loading) {
		content = (
			<StyledCenteredContainer>
				<LoadingSpinner />
			</StyledCenteredContainer>
		)
	} else if (error) {
		content = (
			<StyledCenteredContainer>
				<p>{t('core.privacyPolicy.error')}</p>
			</StyledCenteredContainer>
		)
	} else if (!latest) {
		content = (
			<StyledCenteredContainer>
				<p>{t('core.privacyPolicy.empty')}</p>
			</StyledCenteredContainer>
		)
	} else {
		content = (
			<>
				<Markdown>{latest.text}</Markdown>
			</>
		)
	}

	return (
		<PublicLayout>
			<StyledContent>{content}</StyledContent>
		</PublicLayout>
	)
}

export default TermsOfUsePage
